"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPlugin = hasPlugin;
exports.getPluginSettings = getPluginSettings;
exports.getPluginSetting = getPluginSetting;
exports.getLinkPluginSetting = getLinkPluginSetting;
exports.getHsformattingSettings = getHsformattingSettings;
exports.getHsPersonalizeSettings = getHsPersonalizeSettings;
exports.appendDivToEditor = appendDivToEditor;
exports.getEditorClickTarget = getEditorClickTarget;
exports.isWhitespace = isWhitespace;
exports.isLikelyUrlWithoutProtocol = isLikelyUrlWithoutProtocol;
exports.isQA = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _Domains = require("ContentUtils/constants/Domains");

var _hsSettings = require("./constants/hsSettings");

var _plugins = require("./constants/plugins");

var _hslink = require("./constants/hslink");

function hasPlugin(editor, plugin) {
  return editor.settings.plugins.includes(plugin);
}

function getPluginSettings(editorSettings) {
  if (!editorSettings) {
    return null;
  }

  return editorSettings[_hsSettings.HS_PLUGINS];
}

function getPluginSetting(editor, setting) {
  var pluginSettings = editor.settings[_hsSettings.HS_PLUGINS];

  if (!pluginSettings || typeof pluginSettings[setting] === 'undefined') {
    return null;
  }

  return pluginSettings[setting];
}

function getLinkPluginSetting(editor, setting) {
  var linkPluginSettings = getPluginSetting(editor, _hslink.LINK_SETTINGS);

  if (linkPluginSettings) {
    return linkPluginSettings[setting];
  }

  return null;
}

function getHsformattingSettings(editorSettings, pluginType) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var pluginSettings = getPluginSettings(editorSettings);

  if (!pluginSettings || !pluginSettings[_plugins.HS_FORMATTING] || !pluginSettings[_plugins.HS_FORMATTING][pluginType]) {
    return defaultValue;
  }

  return pluginSettings[_plugins.HS_FORMATTING][pluginType];
}

function getHsPersonalizeSettings(pluginSettings, pluginType) {
  if (!pluginSettings) {
    return null;
  }

  return pluginSettings[pluginType];
}

var isQA = function isQA() {
  return _enviro.default.isQa() || document.domain.indexOf(_Domains.PREVIEW_DOMAINS.qa) >= 0;
};

exports.isQA = isQA;

function appendDivToEditor(editor) {
  var container = editor.getContainer();

  if (container) {
    return container.appendChild(document.createElement('div'));
  }

  return null;
}

function getEditorClickTarget(editor, event) {
  return editor.$(event.target);
}

function isWhitespace() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return !input.trim();
}

function isLikelyUrlWithoutProtocol(possibleUrl) {
  var splitUrl = possibleUrl.split(/([/?].*)/);
  var domainString = splitUrl[0];
  var pathString = splitUrl[1] || '';
  var domainReg = /^([a-zA-Z0-9-]{1,61}\.){0,126}[a-zA-Z0-9-]{1,61}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?\/{0,1}$/;
  var pathReg = /^\/([^\s/]+?\/{0,1})*(\?[^\s/]*?)*?$|^$|^\?[^\s]*?$/;
  return domainReg.test(domainString) && pathReg.test(pathString);
}